
//ドロップダウン
function ddown(targetClass){
  let target = document.querySelectorAll(targetClass);

  for (let i = 0; i < target.length; i++){
    let content = target[i].nextElementSibling;
    let h;
    target[i].addEventListener('click', (e) => {
      if(content.offsetHeight == 0){
        content.style.height = 'auto';
        h = content.offsetHeight;
        e.target.classList.add('is-open');
        content.animate([
          { height: 0 },
          { height: h + 'px' }
        ], {
          duration: 300,
        }).onfinish = () => {
          content.style.height = h + 'px';
          setTimeout(() => {
            content.style.height = 'auto';
          }, 10);
        };
      }else{
        h = content.offsetHeight;
        content.style.height = 0;
        e.target.classList.remove('is-open');
        content.animate([
          { height: h + 'px' },
          { height: 0 }
        ], {
          duration: 300,
        }).onfinish = () => {
          content.style.height = 0;
        };
      }
    });
  }
}

// 自要素以外をクリックしたら閉じる機能を追加する関数
function addCloseOutside(targetClass) {
  let target = document.querySelectorAll(targetClass);

  for (let i = 0; i < target.length; i++){
    let content = target[i].nextElementSibling;

    document.addEventListener('click', (e) => {
      if (!target[i].contains(e.target) && !content.contains(e.target) && content.offsetHeight > 0) {
        content.style.height = 0;
        target[i].classList.remove('is-open');
        content.animate([
          { height: content.offsetHeight + 'px' },
          { height: 0 }
        ], {
          duration: 300,
        }).onfinish = () => {
          content.style.height = 0;
        };
      }
    });
  }
}

ddown('.rnrc__lst-acc');